import { makeStyles } from '@material-ui/core/styles'
import { SCHEDULE_DESKTOP_COLUMN_CALENDAR } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    minHeight: 0,
    overflow: 'hidden',
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      border: `1px solid ${theme.palette.tertiary.backgroundGrey}`,
      padding: `${theme.spacing(0)}px ${theme.spacing(1)}px`,
    },
  },
  visit: {
    padding: `${theme.spacing(0.3)}px ${theme.spacing(1)}px`,
    margin: `${theme.spacing(0.3)}px 0`,
    borderRadius: '0.5em',
    display: 'flex',
    alignItems: 'center',
    background: '#ebf7fa',
    cursor: 'pointer',

    '& svg': {
      height: '1em',
      marginRight: '0.7em',
      fill: theme.palette.tertiary.darkGreen,
      [theme.breakpoints.down(1250)]: {
        marginRight: '0.4em',
      },
    },
    [theme.breakpoints.down(1250)]: {
      padding: `${theme.spacing(0.3)}px ${theme.spacing(0.5)}px`,
    },
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      margin: `${theme.spacing(0.3)}px 0`,
      borderRadius: '0.5em',
      display: 'flex',
      alignItems: 'center',
      background: '#ebf7fa',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      padding: `${theme.spacing(0.3)}px ${theme.spacing(0.5)}px`,
      marginRight: '0.5em',
      '& svg': {
        height: '1em',
        marginRight: '0.7em',
        fill: theme.palette.tertiary.darkGreen,
      },
    },
  },
}))

export default useStyles
